export enum AccountFeaturesEnum {
  // Deprecated
  VEHICLE_DAMAGE_INSPECTION = 'hasVehicleDamageInspection',
  IS_AVAILABLE_TRADING_HUB = 'isAvailableTradingHub',
  HAS_ERACUN = 'hasEracun',
  FEATURE_FLAG_CREATE_VEHICLE_BY_VIN = 'createVehicleByVIN',

  FEATURE_FLAG_ROLES_AND_PERMISSIONS = 'rolesAndPermissions',
  FEATURE_FLAG_ADMINISTRATION_V2 = 'administrationV2',
  FEATURE_FLAG_AB_REDESIGN_V2 = 'abRedesignV2',
  FEATURE_FLAG_AB_LEGACY_RETIRED = 'abLegacyRetired',
  FEATURE_FLAG_ANALYTICS = 'analytics',
  FEATURE_FLAG_DMV_CALCULATION = 'dmvCalculation',
  FEATURE_FLAG_FINANCING = 'financing',
  FEATURE_FLAG_FINANCING_V3 = 'financingV3',
  FEATURE_FLAG_FISCALIZATION_V2 = 'fiscalizationV2',
  FEATURE_FLAG_EINVOICE_INTEGRATION = 'eInvoiceIntegration',
  FEATURE_FLAG_MARKET_STUDY = 'marketStudy',
  FEATURE_FLAG_NLB_LEASING_PRE_UX = 'nlbLeasingPreUX',
  FEATURE_FLAG_SF_PRODUCTS = 'sfProducts',
  FEATURE_FLAG_EDIT_FINAL_SALE_CALCULATION = 'editFinalSaleCalculation',
  FEATURE_FLAG_SPACE_INVOICES_TEMPLATES = 'spaceInvoicesTemplates',
  FEATURE_FLAG_SALE_AND_LEASEBACK = 'saleAndLeaseBack',
  ASSETS = 'assets',
  NLBUX = 'nlbUX',
  LEANPAY = 'leanpay',
  FEATURE_FLAG_WARRANTIES_V2 = 'warrantiesV2',
  WARRANTIES_V1 = 'warrantiesV1',

  MARKET_RESEARCH_CONSENTS = 'marketResearchConsents',
  MOBILE_ACCESS = 'mobileAccess',
  ACCOUNTANT_ACCESS = 'accountantAccess',
  ROLES_AND_PERMISSIONS = 'rolesAndPermissions',
  IMPLEMENTATION_AND_SUPPORT_BY_PHONE = 'implementationAndSupportByPhone',

  DOCUMENTS = 'documents',
  DOCUMENTS_DOCX = 'documentsDOCX',
  FEATURE_FLAG_DEMO_FINANCING = 'demoFinancing',

  FEATURE_FLAG_BUSINESS_UNITS = 'businessUnits',
  HAS_ADDIKO_INTEGRATION = 'hasAddikoIntegration',
  ADDIKO_USE_INVOICES = 'addikoUseInvoices',

  IS_AVAILABLE_DOBERAVTO = 'isAvailableDoberAvto',
  IS_AVAILABLE_SHOPAJ = 'isAvailableShopaj',
  IS_AVAILABLE_VEHICLE_IMPORT = 'isAvailableVehicleImport',
  IS_AVAILABLE_NJUSKALO = 'isAvailableNjuskalo',
  IS_AVAILABLE_BOLHA = 'isAvailableBolha',
  IS_AVAILABLE_MOTIVE_SERVICE = 'isAvailableMotiveService',
  IS_AVAILABLE_EXTERNAL_IMAGE_BACKGROUND_REMOVAL = 'isAvailableExternalImageBackgroundRemoval',
  PRINT_VEHICLE_CARD = 'printVehicleCard',
  IS_AVAILABLE_EXCEL_VEHICLE_IMPORT = 'isAvailableExcelVehicleImport',
  IS_AVAILABLE_INDEX_HR = 'isAvailableIndexHr',
  IS_AVAILABLE_TRADING_HUB_ADVERTISING = 'isAvailableTradingHubAdvertising',
  ONE_CLICK_ADVERTISING = 'oneClickAdvertising',

  CALCULATIONS_AND_COSTS_MANAGEMENT = 'calculationsAndCostsManagement',
  DOCUMENT_ARCHIVE = 'documentArchive',
  ADVERTISEMENT_VIRTUAL_SALON = 'advertisementVirtualSalon',
  ADVERTISEMENT_SOCIAL_NETWORKS = 'advertisementSocialNetworks',
  CLIENTS_MODULE = 'clientsModule',
  CLIENT_REMINDERS = 'clientReminders',
  CLIENT_ACTIVITY_TRACKING = 'clientActivityTracking',
  CLIENT_VAT_SEARCH = 'clientVatSearch',
  ADMINISTRATION_EXPORT = 'administrationExport',
  LIMITED_ADMINISTRATION = 'limitedAdministration',
  DISABLE_PACKAGE_CHANGE = 'disablePackageChange',
  IS_AVAILABLE_EXTENSION_VEHICLE_IMPORT = 'isAvailableExtensionVehicleImport',

  HAS_AI_SUGGESTIONS = 'hasAISuggestions',
  BETA_ADMINISTRATION_EXPORTS = 'betaAdministrationExports',
  IS_AVAILABLE_TERMS_AND_CONDITIONS = 'isAvailableTermsAndConditions',
  HAS_AUTOMATIC_VEHICLE_ARCHIVING = 'hasAutomaticVehicleArchiving',
  HAS_VIRTUAL_SALON_BASIC = 'hasVirtualSalonBasic',
  HAS_VIRTUAL_SALON_MODULE_ACCESS = 'hasVirtualSalonModuleAccess',
  HAS_VIRTUAL_SALON_COMING_SOON = 'hasVirtualSalonComingSoon',
  HAS_VIRTUAL_SALON_PRO = 'hasVirtualSalonPro',
  ANCHOR_PRICE_HR = 'anchorPriceHr',

  MODULE_PACKAGES = 'modulePackages',
  HAS_TEST_DRIVE_DOCUMENT = 'hasTestDriveDocument',
  VEHICLE_ACTIVITY = 'vehicleActivity',
  WORK_ORDER = 'workOrder',
  WARRANTIES = 'warranties',
  HAS_CASH_EXPENDITURES = 'hasCashExpenditures',
  CLIENT_VAT_NUMBER_REQUIRED = 'clientVatNumberRequired',
  HAS_TEST_PLATES = 'hasTestPlates',
  CARPEAK_PROMO = 'carpeakPromo',
  DAMAGE_INSPECTION = 'hasDamageInspection',
  HAS_VEHICLE_INSPECTION_DOCUMENT = 'hasVehicleInspectionDocument',
}
